import { ICommunicationManager } from "OW.Remoting/Remoting/ICommunicationManager";

export abstract class BaseClient {
    protected readonly _communicationManager: ICommunicationManager;

    constructor(communicationManager: ICommunicationManager) {
        this._communicationManager = communicationManager;
    }
}
